import http from "../common/services/httpService";
import { AxiosResponse } from "axios";
import queryString from "query-string";

import { ProfileDto } from "../interfaces/ProfileDto";
import { UserType } from "../common/interfaces/enums/UserType";
import { UserStatsDto } from "../interfaces/admin/UserStatsDto";
import { Nomenclature } from "../common/components/mui-extended/SelectExtended";

const apiEndpoint = "/user";

const getCertificateIdByThumbprintAsync = async (thumbprint: string): Promise<AxiosResponse<number | null>> => {
  return await http.get<number | null>(`${apiEndpoint}/certificateIdByThumbprint?thumbprint=${thumbprint}`);
};

const getProfileDataAsync = async (userId: number): Promise<AxiosResponse<ProfileDto>> => {
  return await http.get<ProfileDto>(`${apiEndpoint}/profile?userId=${userId}`);
};

const getUserStatsByType = (): Promise<AxiosResponse<Record<UserType, UserStatsDto>>> => {
  return http.get<Record<UserType, UserStatsDto>>(`${apiEndpoint}/stats`);
};

const getCertificateExpirations = (): Promise<AxiosResponse<Array<Nomenclature>>> => {
  return http.get<Array<Nomenclature>>(`${apiEndpoint}/certificateExpiration/search`);
};

const getCertificateExpirationsByIds = (ids: Array<number>): Promise<AxiosResponse<Array<Nomenclature>>> => {
  const queryStringIds = queryString.stringify({ ids }, { arrayFormat: "index" });
  return http.get<Array<Nomenclature>>(`${apiEndpoint}/certificateExpiration/init?${queryStringIds}`);
};

export default {
  getCertificateIdByThumbprintAsync,
  getProfileDataAsync,
  getUserStatsByType,
  getCertificateExpirations,
  getCertificateExpirationsByIds,
};
